module.exports = __webpack_public_path__ + "static/hero-80b303ebf58df6af1a79c24444d8e216.png";